<ng-container [ngSwitch]="stage">
  <ng-container *ngSwitchCase="'chat'">
    <ng-container *ngIf="!loading">
      <!-- new conversation button -->
      <div class="floating-buttons">
        <!-- Popout first so its position is stable: the conditional buttons below
             (new conversation appears only once there are messages) then grow
             downward instead of shifting the popout button. -->
        <button *ngIf="popoutEnabled && isInIframe && !popoutService.isPopout" class="button primary" (click)="openPopout()" matTooltip="In neuem Fenster öffnen">
          <span class="material-icons-outlined">open_in_new</span>
        </button>
        <button  *ngIf="!botIsTyping && messages.length && showNewConversationButton;" class="new-conversation-button button primary" (click)="startNewConversation()" matTooltip="Neue Unterhaltung">
          <span class="material-icons-outlined mi-chat">chat</span>
        </button>
        <button *ngIf="loggedIn" class="button primary" (click)="logoutUser()" [matTooltip]="'Abmelden (' + loggedInUser + ')'">
          <span class="material-icons-outlined mi-logout">logout</span>
        </button>
      </div>

      <!-- Freeze overlay while the chat is open in a separate window -->
      <div class="popout-overlay" *ngIf="popoutService.poppedOut">
        <span class="material-icons-outlined popout-overlay__icon">open_in_new</span>
        <p class="popout-overlay__text">Chat in einem neuen Fenster geöffnet.</p>
        <button class="popout-overlay__btn button primary" (click)="popoutService.bringBack()">Zurückholen</button>
      </div>

      <div class="chat-entries" #chatEntriesContainer>
        <div class="chat-entry assistant" *ngIf="welcomeMessage">
          <div class="chat-entry__sender">{{ assistant.name }}</div>
          <div class="chat-entry__message">
            <div [innerHTML]="welcomeMessage | markdown">
            </div>

            <hr *ngIf="sampleQuestions?.length">
            <div class="chat-entry__message__buttons" *ngIf="sampleQuestions?.length">
              <button *ngFor="let sampleQuestions of sampleQuestions" (click)="selectSampleQuestion(sampleQuestions)">
                {{ sampleQuestions }}
              </button>
            </div>
          </div>
        </div>

        <div class="chat-entry assistant" *ngIf="showInitialQuestion && initialQuestion">
          <div class="chat-entry__sender">{{ assistant.name }}</div>
          <div class="chat-entry__message">
            <div [innerHTML]="initialQuestion.content | markdown"></div>
            <div class="chat-entry__message__buttons">
              <button *ngFor="let option of initialQuestion.options" (click)="selectSubset(option)"
                      [disabled]="!initialChoiceRequired && option !== subset">
                {{ option.text }}
              </button>
            </div>
          </div>
        </div>

        <div *ngFor="let entry of messages" class="chat-entry {{entry.role}}">
          <!-- Tool usage bubble (small, centered info bubble) -->
          <ng-container *ngIf="entry.role === 'tool'">
            <div class="tool-usage-bubble" [class.running]="entry.toolStatus === 'running'" [class.completed]="entry.toolStatus === 'completed'">
              <span class="material-icons-outlined">auto_awesome</span>
              <span>{{ entry.toolName }}</span>
              <span class="tool-status-indicator" *ngIf="entry.toolStatus === 'running'">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </span>
              <span class="material-icons-outlined check-icon" *ngIf="entry.toolStatus === 'completed'">check_circle</span>
            </div>
          </ng-container>

          <!-- Regular message bubble -->
          <ng-container *ngIf="entry.role !== 'tool'">
            <div class="chat-entry__sender">{{ entry.role === "user" ? "You" : (entry.agentName ?? assistant.name) }}</div>
            <div class="chat-entry__message">
              <div *ngIf="getFiles(entry).length > 0" class="attached-files">
                <div *ngFor="let file of getFiles(entry)" class="attached-file">
                  <span class="material-icons-outlined">description</span>
                  <span class="filename">{{ file.originalname }}</span>
                  <span class="filesize">({{ file.size | number }} bytes)</span>
                </div>
              </div>
              <div #messageContent [innerHTML]="getProcessedContent(entry) | markdown : { katex: true }"></div>
              <ng-container *ngIf="entry.hint">
                <div class="chat-entry__message__hint" [innerHTML]="entry.hint | markdown"></div>
              </ng-container>

              <!-- Source Pills -->
              <app-source-pills *ngIf="showSourcePills && entry.context && entry.context.length > 0" [contexts]="entry.context"></app-source-pills>

              <ng-container *ngIf="entry.subsetReferences?.length">
                <hr>
                <div>Zu diesem Thema sind weitere Informationen verfügbar, wählen Sie ein Thema an um weitere Fragen speziell
                  dazu zu stellen.
                </div>
                <div class="chat-entry__message__buttons">
                  <button *ngFor="let option of entry.subsetReferences" (click)="selectSubset(option)"
                          [disabled]="(option.value && option.value === subset.value) || (option.persona && option.persona === subset.persona)">
                    {{ option.text }}
                  </button>
                </div>
              </ng-container>
            </div>
            <div *ngIf="entry.showHumanAssistanceMessage && !entry.humanAssistanceRequested" class="chat-entry__message-extension">
              <app-human-assistance-request [message]="entry" [customText]="negativeRatingText" [showEmail]="showEmailOnNegativeRating"></app-human-assistance-request>
            </div>
            <div *ngIf="entry.humanAssistanceRequested" class="chat-entry__message-extension">
              Vielen Dank, wir haben die Anfrage erhalten und werden uns in Kürze melden.
            </div>
            <div *ngIf="(entry.role === 'assistant' && !entry.messageInProgress && entry.id) || entry.context?.length" class="context-button-container">
            <span matTooltipPosition="above" [matTooltip]="'Woher stammt diese Information?'"
                  matTooltipClass="linebreak-tooltip" style="cursor: pointer;" *ngIf="entry.context?.length"
                  (click)="openContext = entry.context;" class="material-icons-outlined mi-question-mark">question_mark</span>
            <span *ngFor="let data of detailsButtons" matTooltipPosition="above" [matTooltip]="data.tooltip"
                    matTooltipClass="linebreak-tooltip" style="cursor: pointer;"
                    (click)="resendMessageWithSubset(data.subset)" class="material-icons-outlined" [ngClass]="['mi-' + (data.icon || 'refresh')]">{{data.icon || 'refresh'}}</span>
              <app-answer-rating [message]="entry" [chatEntriesContainer]="chatEntriesContainer"
                                *ngIf="showRating && entry.role === 'assistant' && !entry.messageInProgress && entry.id"></app-answer-rating>
            </div>
          </ng-container>
        </div>
      </div>

      <div id="assistant-working-indicator" class="assistant-working-indicator" *ngIf="botIsTyping || lastToolUsage" style="padding: 0 1rem;">
        <ng-container *ngIf="!lastToolUsage">{{ assistant.name }} is working...</ng-container>
        <ng-container *ngIf="lastToolUsage">
          <span class="material-icons-outlined mi-auto-awesome">auto_awesome</span>
          <span>{{ lastToolUsage.agentName }} is using {{ lastToolUsage.toolName }}</span>
        </ng-container>
      </div>

      <hr>

      <div style="display: flex; flex-direction: row; align-items: flex-end; padding: 0 1rem; gap: 0.5rem;">
        <!-- subset-context indicator as icon and tooltip as text -->
        <button *ngIf="subset?.text && (subset?.value || subset?.persona || subset?.functions)" (click)="selectSubset()" matTooltipPosition="above"
                [matTooltip]="'Fokus-Thema: ' + subset.text + '.\n(Klick = Themen-Fokus entfernen)'"
                matTooltipClass="linebreak-tooltip" class="button primary"
                style="flex-grow: 0; padding: 0 0.5rem; display: flex; align-items: center; margin: 0;">
          <img src="assets/subset-focus.svg" style="height: 1.3rem; width: 1.3rem;"/>
        </button>
        <!-- filepicker if showFilePicker = true as a paper-clip button -->
        <button *ngIf="showFilePicker" (click)="filePicker.click()" matTooltipPosition="above"
                [matTooltip]="'Datei auswählen'" matTooltipClass="linebreak-tooltip" class="button primary icon-button">
          <span class="material-icons-outlined mi-attach-file">attach_file</span>
        </button>
        <input #filePicker type="file" (change)="onFileSelected($event)" style="display: none;"/>
        <textarea #queryInput id="query-input" [placeholder]="inputPlaceholder" style="flex-grow: 1;" [(ngModel)]="inputText"
               (keydown)="handleKeyDown($event)" (paste)="handlePaste($event)" (input)="autoResize()" tabindex="0" rows="1"></textarea>
        <button id="send-button" class="send-button" style="flex-grow: 0;" (click)="sendMessage()"
                [disabled]="!inputText || botIsTyping || initialChoiceRequired">
          {{ sendButtonLabel }}
        </button>
      </div>
      <div *ngIf="pickedFiles.length" style="display: flex; flex-direction: row; gap: 1rem; padding-left: 1.5rem; margin-top: 0.25rem;">
        <div *ngFor="let file of pickedFiles" class="file-preview">
          <span class="material-icons-outlined mi-file" style="font-size: 1rem; margin: 0;">attach_file</span>
          <span>{{ file.name }}</span>
          <div (click)="removeFile(file)" class="remove-button">×</div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="openContext" class="open-context">
      <div class="close-button" (click)="openContext = null">&times;</div>
      <div class="content">
        <ng-container *ngFor="let context of openContext">
          <h4 [innerHTML]="context.sourceString | markdown"></h4>
          <pre>
          [...] {{ context.chunk?.trim() }} [...]
        </pre>
        </ng-container>
      </div>
    </div>

    <app-user-info-query [requiredFields]="queryUserInfo"></app-user-info-query>
  </ng-container>
  <ng-container *ngSwitchCase="'blocked'">
    <app-message-box title="Der Chatbot ist leider nicht verfügbar." icon="block" type="blocked">
      <p>Wir konnten den gewünschten Chatbot nicht finden. Bitte überprüfen Sie den Link und versuchen Sie es erneut.</p>
      <p>Bei Fragen schreiben Sie uns gerne jederzeit an <a href="mailto:info@omm-solutions.de">info@omm-solutions.de</a>.</p>
    </app-message-box>
  </ng-container>
  <ng-container *ngSwitchCase="'pending'">
    <app-message-box [title]="authPageConfig?.pendingTitle || authPageConfig?.title || 'Freigabe erforderlich'" icon="lock_clock" type="pending">
      <ng-template #footer>
        <button class="button primary" (click)="logoutUser()">{{ authPageConfig?.logoutLabel || "Abmelden" }}</button>
      </ng-template>
      <p>{{ authPageConfig?.pendingDescription || 'Ihre Zugriffsanfrage für diesen Chatbot wurde registriert. Bitte warten Sie, bis diese bearbeitet wurde.' }}</p>
      <p *ngIf="authPageConfig?.contactMail !== ''">Bei Fragen schreiben Sie uns gerne jederzeit an <a [href]="'mailto:' + (authPageConfig?.contactMail ?? 'info@omm-solutions.de')">{{authPageConfig?.contactMail ?? 'info@omm-solutions.de'}}</a>.</p>
    </app-message-box>
  </ng-container>
  <ng-container *ngSwitchCase="'login'">
    <app-message-box [title]="authPageConfig?.title || 'Authentifizierung erforderlich'" icon="lock" type="login">
      <ng-template #footer>
        <button class="button primary" (click)="startLogin()">{{ authPageConfig?.loginLabel || "Anmelden" }}</button>
        <button *ngIf="publicRegistrationAllowed" class="button primary" (click)="startRegister()">{{ authPageConfig?.registerLabel || "Registrieren" }}</button>
      </ng-template>

      <p>{{ authPageConfig?.description || "Bitte melden Sie sich an, um den Chatbot zu verwenden." }}</p>
    </app-message-box>
  </ng-container>
  <ng-container *ngSwitchCase="'denied'">
    <app-message-box [title]="authPageConfig?.deniedTitle || 'Zugriff verweigert'" icon="lock" type="denied">
      <ng-template #footer>
        <button class="button primary" (click)="logoutUser()">{{ authPageConfig?.logoutLabel || "Abmelden" }}</button>
      </ng-template>

      <p>{{ authPageConfig?.deniedDescription || "Sie haben keinen Zugriff auf diesen Chatbot." }}</p>
    </app-message-box>
  </ng-container>
</ng-container>
<ng-container *ngIf="authPageConfig?.legalDocuments"><app-legal-documents [legalDocuments]="authPageConfig?.legalDocuments"></app-legal-documents> </ng-container>
